import * as React from 'react';
import { Table, Card } from 'antd';
import service from '../../service/apolloclient.service';
import LocalStorage from '../../service/localstorage';
import '../../css/ExternalDashboard.scss';
import TestList from '../test/TestList';
import TestPdf from '../test/testPdf';
// import PdfCreation from '../common/pdfCreation';
import CanvasTestView from '../common/canvasTestView';
import { Link } from 'react-router-dom';
import Utils from '../common/utils';
import strings from '../../eyeguide-localization/strings.dashboard';
import { CustomSorter } from '../Sorter';
import * as jsPDF from 'jspdf';

var doc = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'letter',
});
var canvas: any = [];

interface IExternalDashboardProps {
    shareuserid: any;
    match: any;
}

interface IExternalDashboardState {
    columnData: any;
    columns: any;
    loading: boolean;
    shareTests: any;
    openIndices: any;
    emptyText: string;
    testListLoading: boolean;
    testListText: string;
    rtaColumns: any;
    rtaColumnData: any;
    testData: any;
}

export default class ExternalDashboard extends React.Component<IExternalDashboardProps, IExternalDashboardState> {

    constructor(props: IExternalDashboardProps) {
        super(props);
        this.state = {
            columnData: [],
            columns: [],
            loading: true,
            shareTests: new Map(),
            openIndices: [],
            emptyText: '',
            testListLoading: true,
            testListText : '',
            rtaColumnData: new Map(),
            rtaColumns: [],
            testData: null
        }; 
        this.onExpand = this.onExpand.bind(this);
        // history.pushState(null, '', document.URL);
    }

    async componentDidMount() {        
        console.log(this.props);
        strings.setLanguage(navigator.language);
        let shares = [];
        let ser = new service();
        shares = await ser.getShares(this.props.shareuserid);
        console.log('componentDidMount', shares);
        let columnData = this.buildData(shares);
        let columns = this.buildColumns();
        console.log('columns', columns);
        console.log('columnData', columnData);
        this.setState({
            columnData,
            columns,
            loading: false,
            emptyText: shares.length === 0 ? 'No Data' : '',
            shareTests: new Map(),
            rtaColumnData: new Map()
        });
        this.getIndexes();
    }

    render() {
        console.log('render', this.state.openIndices);
        return (
            <div className="ExternalDashboard contentWithoutTitle">
                <Card title={'Welcome ' + this.getUsername()} >
                    <Table 
                        style={{cursor: 'pointer', pointerEvents: this.state.loading ? 'none' : 'auto'}}
                        columns={this.state.columns} 
                        dataSource={this.state.columnData} 
                        rowKey={record => record.shareid}
                        rowClassName={(record, index) => 'rows'}
                        expandRowByClick={true}
                        expandedRowRender={this._expandRowRender}
                        onExpand={this.onExpand}
                        pagination={false}
                        expandedRowKeys={this.state.openIndices}
                        loading={this.state.loading}
                        locale={{ emptyText: this.state.emptyText }}
                    /> 
                </Card>
            </div>
        );
    }

    notifyTestDownload = () => {
        canvas = [];
        doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
        this.setState({
            loading: !this.state.loading,
            testData: null
        });
    }

    /**
     * Render function called when row is expanded. Returns the HTML elements to display
     */
    _expandRowRender = (record: any, expanded: any, expandedRowKeys: any) =>  {  
        console.log('_expandRowRendercalled');
        console.log('this.state.shareTests', record);
        console.log('expandedRowKeys', expanded);

        if (!this.state.shareTests.has(record.shareid)) {
            console.log('calling gettesst');
            this.getTests(record.shareid);
        }
        // let testid: any = this.state.shareTests.length > 0 ?
        // this.state.shareTests[0].testid : 0 ;
        return(
            <div>
             <Card title={strings.lsSharedTestTxt} bordered={false}>
            <TestList
                organizationID=""
                rosterID=""
                tests={this.state.shareTests.has(record.shareid) ? this.state.shareTests.get(record.shareid) : []}
                notifySelectedTests={undefined}
                organizationName={''}
                enableTitleSpace={false}
                pagination={false}
                sorting={false}
                showAthelete={true}
                showDownloadAction={true}
                loading={this.state.testListLoading}
                emptyText={this.state.testListText}
                showEditAction={false}
                notifyTestUpdated={undefined}
                notifyTestDownload={this.notifyTestDownload}
            />
             </Card>
            {record.returntoactivity === 1 ? 
            <Card  title={strings.lsSharedReturnToActivityTxt} bordered={false}>
                <Table 
                    style={{cursor: 'pointer'}}
                    columns={this.state.rtaColumns} 
                    dataSource={this.state.rtaColumnData.get(record.shareid)} 
                    rowClassName={(rec, index) => 'rows'}
                    pagination={false}
                    loading={this.state.loading}
                    locale={{ emptyText: this.state.emptyText }} 
                />
            </Card> 
                // <Link 
                //     to={'/viewTest/' + (this.state.shareTests.get(record.shareid) !== undefined ?
                //     this.state.shareTests.get(record.shareid)[0].testid : '0') + '/enableRta'}
                // >
                // <Button className="rtaButton" type="primary" onClick={this.showReturnToActivity}> 
                //     Return to Activity 
                // </Button>
                // </Link>
                : '' }

            </div>
        );
    }

    /**
     * Gets the tests for a share from the server
     * @param shareid Share id of share for which the tests are to be fetched
     */
    async getTests(shareid: any) {
        console.log('external shareid', shareid);
        let ser = new service();
        let shareTests: any = await ser.getSharetests(shareid);
        console.log('getsharetest', shareTests);
        let testMap = this.state.shareTests;
        testMap.set(shareid, shareTests);
        let rtaDataTestMap = this.state.rtaColumnData;
        
        if (!this.state.rtaColumnData.has(shareid)) {
            let rtaData = this.getRTAData(shareTests, shareid );
            let columnData = this.buildRTAData(rtaData);
            rtaDataTestMap.set(shareid, columnData);
        }
        let columns = this.buildRTAColumns();
        this.setState({
            shareTests: testMap,
            testListLoading: false,
            testListText: shareTests.length === 0 ? 'No Data' : '',
            rtaColumnData: rtaDataTestMap,
            rtaColumns: columns
        });
    }
    
    /**
     * Fetches the test list for the share that is expanded
     * This function is called by list itself
     */
    private onExpand = (expanded: any, record: any) => {
        console.log('called');
        let openIndices = this.state.openIndices;
        if (expanded) {
            openIndices.push(record.shareid);
            this.setState({
                openIndices: openIndices
            });
        } else {
            let index: number = 0;
            openIndices.forEach((value: any, i: number) => {
                if (value.shareid === value.shareid) {
                    index = i;
                }
            }
            );
            openIndices.splice(index, 1);
            this.setState({
                openIndices: openIndices
            });
        }
    }

    private buildData(shares: Array<any>) {
        let columnData: Array<any> = [];
        shares.forEach( (element: any) => {
            let data = {
                name: element.username,
                organization: element.organization,
                time: Utils.getDate(element.time),
                shareid: element.shareid,
                returntoactivity: element.returntoactivity,
                tests: element.tests
            };
            columnData.push(data);
        }); 
        return columnData;
    }
  
    private buildColumns() {
        let columns = [
          {
            title: strings.lsSharedBy,
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            className: 'rows',
            onHeaderCell: (column) => {
                console.log('onHeaderCell' , column);
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsOrgTxt,
            dataIndex: 'organization',
            sorter: (a: any, b: any) => a.organization.localeCompare(b.organization),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                console.log('onHeaderCell' , column);
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsDateTxt,
            dataIndex: 'time',
            sorter: (a: any, b: any) => a.time.localeCompare(b.time),
            className: 'rows',
            onHeaderCell: (column) => {
                console.log('onHeaderCell' , column);
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsActionTxt,
            dataIndex: 'shareid',
            className: 'rows',
            render: (text: any, record: any) => (
                <div>
                    <a 
                        className="linkSpacing"
                        onClick={ (e) => {    
                            console.log('e in onlcick', record);  
                            e.stopPropagation();
                            this.setState(
                                {loading: true},
                                () => this.downloadAllTests(record.shareid)
                            );
                        }
                        }
                    >{strings.lsDownloadAllTxt}
                    </a>
                </div>
            ),
            onHeaderCell: (column) => {
                console.log('onHeaderCell' , column);
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          }
        ];
        return columns;
    }

    private buildRTAColumns() {
        let columns = [
          {
            title: strings.lsProfileNameTxt,
            dataIndex: 'name',
            className: 'rows'
          },
          {
            title: strings.lsDateRangeTxt,
            dataIndex: 'date_range',
            className: 'rows'
          },
          {
            title: strings.lsTestTxt,
            dataIndex: 'testCount',
            className: 'rows'
          },
          {
            title: strings.lsActionTxt,
            dataIndex: 'shareid',
            className: 'rows',
            render: (text: any, record: any) => (
                <div>
                    <Link
                        to={'/viewTest/' + (this.state.shareTests.get(record.shareid) !== undefined ?
                     this.state.shareTests.get(record.shareid)[0].testid : '0') + '/enableRta'}
                    >{strings.lsViewTxt}
                    </Link>
                </div>
            ),
          }
        ];
        return columns;
    }

    private buildRTAData(element: any) {
        let columnData: Array<any> = [];
        let data = {
            name: element.name,
            date_range: element.daterange,
            testCount: element.testCount,
            shareid: element.shareid
        };
        columnData.push(data);
        return columnData;
    }

    private getRTAData(sharetests: any, shareid: any) {
        if (sharetests.length > 0) {
            let total = sharetests.length;
            console.log('getRTADatasharetest', sharetests[0]);
            console.log(sharetests[0].testtimestamp.toString() + '-' + 
                            sharetests[total - 1].testtimestamp.toString());

            return {
                name : sharetests[0].athlete.firstname + ' ' +
                    sharetests[0].athlete.lastname ,
                daterange: Utils.getDate(sharetests[0].testtimestamp) + '—' + 
                                Utils.getDate(sharetests[total - 1].testtimestamp),
                testCount: total,
                shareid: shareid
            };
        } else {
            return {
                
            };
        }
    }

    /**
     * Gets the logged in external user 's name
     */
    private getUsername() {
        let storage = new LocalStorage();
        return storage.getUserName();
    }

    /**
     * This function inititates download of all tests belonging to a share
     * @param shareid 
     */
    private async downloadAllTests(shareid: string) {
        await this.getTests(shareid);
        console.log('Download all tests', this.state.shareTests);
        let tests: any ;
        if (this.state.shareTests.has(shareid)) {
            tests  = this.state.shareTests.get(shareid);
        } else {
            await this.getTests(shareid);
            this.state.shareTests.get(shareid);
        }
        let ser = new service();
        tests.reduce(
            (prev, test, i) => {
                return prev.then(async () => {
                    let testResult = await this.getTestDetails(test.testid, 0);
                    let testHistory = await ser.getTestsAfterLastBaseline(
                        testResult.playerid, testResult.testtimestamp
                    );
                    return TestPdf({
                        index: i,
                        state: {testResult, testHistory},
                        doc: doc,
                        isLast: i === tests.length - 1,
                        setCanvas: () => this.downloadTest(testResult, i),
                        notifyDownload: () => this.notifyTestDownload()
                    });
                });
            },
            Promise.resolve()
        );
    }

    private async downloadTest(testResult: any, index: number) {
        let profileInfo: any = [];
        let baselineTestData: any;
        if (testResult.baseline === 1) {
            baselineTestData = testResult;
            console.log('in baseline');
        } else {
            baselineTestData = await this.getTestDetails(testResult.testid, 1);
        }
        let isOldData = testResult.calibaratedtestcoords === null ? true : false;
        let isOldDataBaseline = baselineTestData.calibaratedtestcoords === null ? true : false;
        canvas.push(document.createElement('canvas'));
        canvas[index].width = 1024;
        canvas[index].height = 768;
        profileInfo.push({
            profileName: testResult.athlete.firstname + ' ' + testResult.athlete.lastname,
            testtimestamp: testResult.testtimestamp,
            isBaseline: testResult.baseline === 1,
            orgName: testResult.athlete.organizationname
        });
        let canvasView: any ;
        canvasView = new CanvasTestView(
            canvas[index], this.getCoords(baselineTestData),
            this.getCoords(testResult) ,
            testResult.baseline === 1, this.checkIfTestsIsImpaired(testResult.range), 
            Utils.getLocalizedTestType(testResult.range), 
            Utils.formatNumber(testResult.score, 2), 
            isOldData, isOldDataBaseline
        );
        await canvasView.setCanvasView();
        let img: any = new Image();
        img.src = canvas[index].toDataURL();
        img.width = 1024 * 0.5;
        img.height = 768 * 0.5;
        return img;
    }

    /**
     * Feteches the test coordinates from server
     * @param testid 
     * @param baseline Specifies if test is baseline or no. 1: baseline, 0: Test
     */
    private async getTestDetails(testid: string, baseline: number) {
        let ser = new service();
        let data = await ser.getTestResults(testid, baseline);
        console.log('test results', data);
        return data[0];
    }

    /**
     * Formats the test coordinates to set for Test View
     * @param data Data containing test details
     */
    private getCoords(data: any) {
        return  this.formatCorrds( 
            data.calibaratedtestcoords === null ? 
                data.testcoords : data.calibaratedtestcoords);
    }

    private checkIfTestsIsImpaired(range: string) {
        return range !== undefined ? 
        range.indexOf(strings.lsImpairedTxt) !== -1 : false;
     }
 
     private formatCorrds(coords: any) {
         console.log('formatCorrds', coords);
         if (coords !== undefined) {
             let data = coords;
             let formattedData: any = [];
             data.forEach((e: any) => {
                 formattedData.push({x: e.eye_x, y: e.eye_y});
             });
             console.log('formattedData', formattedData);
             return formattedData;
         }
     }
 
     private getIndexes() {
         console.log('openIndices', this.state.openIndices);
         let indexes: any = [];
         this.state.columnData.forEach((e: any) => {
             if (e.shareid === this.props.match.params.shareid) {
                 indexes.push(e.shareid);
             }
         });
         console.log('openIndices', indexes);
         this.setState({
            openIndices: indexes
         });
         console.log('openIndices', this.state.openIndices);
     }

} 



// WEBPACK FOOTER //
// ./src/components/external/Dashboard.tsx